import React, { useEffect } from "react";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import TestModeSetupPrompt from "components/TestModeSetupPrompt";
import { useCanEnableTestMode } from "utils/hooks";
import { useHasTestClientKey, useIsAuthed } from "utils/selectors";
import { useFormikContext } from "formik";
import { FORM_KEY } from "utils/constants/form";
import { CONTACTLESS_PREVIEW_MODE } from "constants/contactless";

const Toggles = () => {
  const isAuthed = useIsAuthed();
  const canEnableTestMode = useCanEnableTestMode() && isAuthed;
  const hasTestClientKey = useHasTestClientKey();
  const { values, setFieldValue } = useFormikContext();
  const {
    [FORM_KEY]: { route, shortId, testMode, previewMode }
  } = values;
  const testModePath = `${FORM_KEY}.testMode`;
  const previewModePath = `${FORM_KEY}.previewMode`;

  const isPage = route && !shortId;

  useEffect(() => {
    if (isPage && previewMode === CONTACTLESS_PREVIEW_MODE.PRODUCT) {
      setFieldValue(previewModePath, CONTACTLESS_PREVIEW_MODE.CODE);
    }
  }, [isPage, previewMode]);

  if (isPage) {
    return null;
  }

  let testToggle;
  if (isAuthed) {
    if (hasTestClientKey) {
      testToggle = (
        <div className="flex flex-column w-100">
          <div className="flex flex-row justify-between items-center w-100">
            <div className="f5 fw6">Test</div>
            <Toggle
              {...getToggleProps({
                active: testMode,
                setFieldValue: (_, active) => {
                  setFieldValue(testModePath, active);
                }
              })}
            />
          </div>
          <div className="f6 lh-copy pt1">
            Toggle between live or test checkout mode.
          </div>
        </div>
      );
    } else if (canEnableTestMode) {
      testToggle = (
        <TestModeSetupPrompt
          subheader="To enable test mode, you need to login to your Stripe account as a test user. Once enabled, you'll be able to successfully complete QR code checkout using test payment details."
          customClasses={{
            container:
              "w-100 flex flex-column justify-between items-start bg-white",
            header: "f5 fw6",
            subheader: "f6 lh-copy"
          }}
        />
      );
    }
  }

  return (
    <div className="w-100 center pt3">
      <div className="flex flex-column ba br2 items-start hairline-1 pa3 black-80 bg-white db">
        <div className="flex flex-column w-100">
          <div className="flex flex-row justify-between items-center w-100">
            <div className="f5 fw6">Code preview</div>
            <Toggle
              {...getToggleProps({
                active: previewMode === CONTACTLESS_PREVIEW_MODE.CODE,
                setFieldValue: (_, active) => {
                  const updatedMode = active
                    ? CONTACTLESS_PREVIEW_MODE.CODE
                    : CONTACTLESS_PREVIEW_MODE.PRODUCT;

                  setFieldValue(previewModePath, updatedMode);
                }
              })}
            />
          </div>
          <div className="f6 lh-copy pt1">
            Toggle between QR code or product preview.
          </div>
        </div>
        {testToggle && (
          <div className="pt3 mt3 w-100 bt hairline-1">{testToggle}</div>
        )}
      </div>
    </div>
  );
};

export default Toggles;
